import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "hideLabel", "id", "indeterminate", "isDisabled", "label", "labelPosition", "name", "onChange", "size", "truncateLabel"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { KEY_CODES } from "../../utilities";
import PropTypes from 'prop-types';
import { BaseCheckbox, StyledCheckboxWrapper } from "../blocks";
import { getStateStyles } from "../checkboxStateStyles";
import { CHECKBOX_LABEL_POSITIONS, CHECKBOX_SIZES } from "../constants";
import { CheckboxIndicator, CheckboxLabel } from "../elements";
import { ElementStateWrapper } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var triggerKeys = [KEY_CODES.SPACE];
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      hideLabel = _ref.hideLabel,
      id = _ref.id,
      indeterminate = _ref.indeterminate,
      isDisabled = _ref.isDisabled,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      name = _ref.name,
      onChange = _ref.onChange,
      size = _ref.size,
      truncateLabel = _ref.truncateLabel,
      other = _objectWithoutProperties(_ref, _excluded);

  var renderIndicator = function renderIndicator() {
    return /*#__PURE__*/_jsx(CheckboxIndicator, {});
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/_jsx(CheckboxLabel, {});
  };

  return /*#__PURE__*/_jsx(ElementStateWrapper, _objectSpread(_objectSpread({
    styledSelector: StyledCheckboxWrapper,
    stateStyles: getStateStyles(checked, isDisabled),
    triggerClickEventAsKeyDown: true,
    triggerKeys: triggerKeys
  }, other), {}, {
    children: /*#__PURE__*/_jsx(BaseCheckbox, {
      checked: checked,
      hideLabel: hideLabel,
      id: id || name,
      indeterminate: indeterminate,
      isDisabled: isDisabled,
      label: label,
      labelPosition: labelPosition,
      name: name,
      onChange: onChange,
      ref: ref,
      renderIndicator: renderIndicator,
      renderLabel: renderLabel,
      size: size,
      truncateLabel: truncateLabel
    })
  }));
});
Checkbox.propTypes = {
  /** The current value of checkbox - checked or unchecked */
  checked: PropTypes.bool.isRequired,

  /** Visually hides checkbox label */
  hideLabel: PropTypes.bool,

  /** Identifier for this checkbox */
  id: PropTypes.string,

  /** Changes the icon and sets checkbox indeterminate parameter state */
  indeterminate: PropTypes.bool,

  /** Disables to change the value of checkbox and shows it visually disabled */
  isDisabled: PropTypes.bool,

  /** Checkbox label */
  label: PropTypes.node,

  /** Places label before or after indicator */
  labelPosition: PropTypes.oneOf(Object.values(CHECKBOX_LABEL_POSITIONS)),

  /** Name of the checkbox */
  name: PropTypes.string.isRequired,

  /** Callback that is called when interacting with checkbox */
  onChange: PropTypes.func.isRequired,

  /** Checkbox size */
  size: PropTypes.oneOf(Object.values(CHECKBOX_SIZES)),

  /** If true, truncates the checkbox label */
  truncateLabel: PropTypes.bool
};
Checkbox.defaultProps = {
  hideLabel: false,
  id: '',
  indeterminate: false,
  isDisabled: false,
  label: '',
  labelPosition: CHECKBOX_LABEL_POSITIONS.AFTER,
  size: CHECKBOX_SIZES.STANDARD,
  truncateLabel: false
};
export { Checkbox };